export default class ValidateQuery {
  static isValid(query) {
    // Don't validate empty query
    if (query.length === 0) {
      return null;
    }

    // Query is always invalid if length is even
    if (query.length % 2 === 0) {
      console.error("Query invalid (length should be an odd number)");
      return false;
    }

    // The number of opening and closing brackets should be equal
    const openingBrackets = query.filter(
      q => q.type === "operator" && q.value === "bracket_open"
    ).length;
    const closingBrackets = query.filter(
      q => q.type === "operator" && q.value === "bracket_close"
    ).length;
    if (openingBrackets !== closingBrackets) {
      console.error(
        "Query invalid (number of opening and closing brackets should be equal)"
      );
      return false;
    }

    let valid = true;

    // Full query tests
    if (!this.equalBrackets(query)) {
      console.error("Query invalid - unequal brackets");
      valid = false;
    }

    if (!this.validOuter(query[0])) {
      console.error("Query invalid - query cannot start with AND, OR, NOT");
      console.log(query[0]);
      valid = false;
    }

    if (!this.validOuter(query.slice(-1)[0])) {
      console.error("Query invalid - query cannot end with AND, OR, NOT");
      valid = false;
    }

    // Order tests
    query.forEach((q, i) => {
      const prevItem = query[i - 1] || null;
      const nextItem = query[i + 1] || null;

      // If current item is opening bracket
      if (this.isOpeningBracket(q)) {
        // Previous item should be AND/OR/NOT
        if (prevItem && !this.isAndOrNot(prevItem)) {
          valid = false;
          console.error("Query invalid (error 1)");
        }

        // Next item should be filter/TTC/indice or opening bracket
        if (
          nextItem &&
          !(this.isFilterTTCIndice(nextItem) || this.isOpeningBracket(nextItem))
        ) {
          valid = false;
          console.error("Query invalid (error 2)");
        }
      }

      // If current item is closing bracket
      if (this.isClosingBracket(q)) {
        // Previous item should be filter/TTC/indice
        if (prevItem && !this.isFilterTTCIndice(prevItem)) {
          valid = false;
          console.error("Query invalid (error 3)");
        }

        // Next item should be AND/OR/NOT or closing bracket
        if (
          nextItem &&
          !(this.isAndOrNot(nextItem) || this.isClosingBracket(nextItem))
        ) {
          valid = false;
          console.error("Query invalid (error 4)");
        }
      }

      // If current item is AND, OR, NOT
      if (this.isAndOrNot(q)) {
        // Previous item should by anything but opening bracket
        if (prevItem && this.isOpeningBracket(prevItem)) {
          valid = false;
          console.error("Query invalid (error 5)");
        }

        // Next item should by anything but closing bracket
        if (nextItem && this.isClosingBracket(nextItem)) {
          valid = false;
          console.error("Query invalid (error 6)");
        }
      }

      // If current item is filter/TTC/indice
      if (this.isFilterTTCIndice(q)) {
        // Previous item should be anyting but filter/TTC/indice
        if (prevItem && this.isFilterTTCIndice(prevItem)) {
          valid = false;
          console.error("Query invalid (error 7)");
        }

        // Next item should be anyting but filter/TTC/indice
        if (nextItem && this.isFilterTTCIndice(nextItem)) {
          valid = false;
          console.error("Query invalid (error 8)");
        }
      }

    });

    return valid;
  }

  static haveAlienConcepts(query){
    let valid = true;
    query.forEach((q) => {
      if(q.value.includes("TTC_XXX")){
        console.log(q);
        valid = false;
      }
    })
    return valid
  }

  static isOpeningBracket(item) {
    return item.type === "operator" && item.value === "bracket_open";
  }

  static isClosingBracket(item) {
    return item.type === "operator" && item.value === "bracket_close";
  }

  static isBracket(item) {
    return (
      item.type === "operator" &&
      (item.value === "bracket_open" || item.value === "bracket_close")
    );
  }

  static isAndOrNot(item) {
    return (
      item.type === "operator" &&
      (item.value === "AND" || item.value === "OR" || item.value === "NOT")
    );
  }

  static isFilterTTCIndice(item) {
    return item.type !== "operator";
  }

  static equalBrackets(query) {
    let open = query.filter(
      item => item.type === "operator" && item.value === "bracket_open"
    ).length;
    let close = query.filter(
      item => item.type === "operator" && item.value === "bracket_close"
    ).length;
    return open === close;
  }

  static validOuter(item) {
    return !(
      item.type === "operator" &&
      (item.value === "AND" || item.value === "OR" || item.value === "NOT")
    );
  }
}
